import { render } from "./padresevento.vue?vue&type=template&id=b0158318&scoped=true"
import script from "./padresevento.vue?vue&type=script&lang=js"
export * from "./padresevento.vue?vue&type=script&lang=js"

import "./padresevento.vue?vue&type=style&index=0&id=b0158318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0158318"]])

export default __exports__